<template>
    <div class="col backgroundForm">
        <div class="col col-md-10 offset-md-1">
            <div class="col col-md-6 offset-md-3">
      <div class="alert alert-danger" role="alert">
        <h4 class="alert-heading">Reportes ORDOP</h4>        
        <hr>
        <p v-if="cDtsUser.role === 4 ">Capitania de Puerto {{ cDtsUser.name_port | capitalize }} </p>
        <p v-else>Reporte de Operaciones realizadas por los Capitanes de Puerto </p>
      </div>

        <transition name="fade" mode="out-in">
            <div class="form-row" v-if="cDtsUser.role !== 4">
                <div class="form-group col-12 col-md-6 offset-md-3">
                    <label for="nombre_embarcacion">Capitania</label>  
                            <!-- listar las capitanias -->
                    <select name="captain_ordop" class="form-control" id="captain_ordop" v-model="captain_ordop_report">
                        <option v-for="port in ports" :value="port.id" :key="port.id">{{ port.name_port }}</option>
                    </select>                         
                </div>
            </div>
        </transition>
    </div>
            

            <nav>
                <div class="nav nav-pills" id="nav-tab" role="tablist">
                    <a class="nav-item nav-link active" id="nav-init-traffic" data-toggle="tab" href="#nav-init" role="tab" aria-controls="nav-home" aria-selected="true">Individual</a>
                    <a class="nav-item nav-link" id="nav-second-traffic" data-toggle="tab" href="#nav-second" role="tab" aria-controls="nav-profile" aria-selected="false">Resumen</a>
                    <a class="nav-item nav-link" id="nav-second-traffic" data-toggle="tab" href="#nav-tirdh" role="tab" aria-controls="nav-profile" aria-selected="false">Millas Navegadas</a>
                </div>
            </nav>
            

            <div class="tab-content" id="nav-tabContent">
                <br>            
                <div class="tab-pane fade show active"  id="nav-init" role="tabpanel" aria-labelledby="nav-home-tab">                    
                    

                    <h6>Seleccione el mes de Operaciones</h6>
                    <hr>
                    <div class="form-row">
                        <div class="form-group col-12 col-md-4 offset-md-2">
                            <label for="date_init_ordop">Mes </label>
                            <select name="month_r" id="" class="form-control" v-model="month_select">
                                <option v-for="m in months" :value="m.c" :key="m.c" :selected="m.c==month_select">{{ m.m }}</option>
                            </select>
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="time_init_ordop">Gestion </label>
                            <select name="year_r" id="year_r" class="form-control" v-model="year_select">
                                <option v-for="y in years" :value="y.c" :key="y.c" :selected="y.c==year_select">{{ y.c }}</option>
                            </select>
                        </div>
                    </div>

                    <button class="btn btn-outline-warning col-12 col-md-4 offset-md-4" @click="mGetIndividuallyOrdop">
                        <font-awesome-icon icon="list" size="2x" />
                    </button>

                    <br><br>
                    <transition name="fade" mode="out-in">
                    <div class="col-12 table-responsive" v-if="ordopsIndividually.length > 0">
                        
                        <table class="table table-striped">
                            <thead class="thead-dark">
                                <tr>
                                    <th scoped="col">#</th>
                                    <th scoped="col">Titulo ORDOP</th>
                                    <th scoped="col">Tarea</th>
                                    <th scoped="col">Fecha</th>
                                    <th scoped="col">Reporte</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(o, index) in ordopsIndividually" :key="o.id">
                                    <td>{{ index+1 }}</td>
                                    <td>{{ o.titulo_ordop }}</td>
                                    <td>{{ o.tarea }}</td>
                                    <td>{{ o.fecha_inicio }}</td>
                                    <td><button class="btn btn-success" @click="mReportI(o.id)"><font-awesome-icon icon="file-pdf" /></button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    </transition>
                    
                </div>
                <!-- end first tab traffic -->
                
                <!-- init tab second -->
                <div class="tab-pane fade" id="nav-second" role="tabpanel" aria-labelledby="nav-profile-tab">
                    
                    <h6>Resumen ORDOP</h6>
                    <hr>
                    <br><br>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-4 offset-md-2">
                            <label for="date_init_ordop">Mes </label>
                            <select name="month_r" id="" class="form-control" v-model="month_select">
                                <option v-for="m in months" :value="m.c" :key="m.c" :selected="m.c==month_select">{{ m.m }}</option>
                            </select>
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="time_init_ordop">Gestion </label>
                            <select name="year_r" id="year_r" class="form-control" v-model="year_select">
                                <option v-for="y in years" :value="y.c" :key="y.c" :selected="y.c==year_select">{{ y.c }}</option>
                            </select>
                        </div>
                    </div>

                    <button class="btn btn-outline-dark col-12 col-md-4 offset-md-4" @click="mGetReportGral">
                        <font-awesome-icon icon="file-pdf" size="2x" />
                    </button>

                </div>
                <!-- end second tab -->

                <!-- init tab tirdh -->
                <div class="tab-pane fade" id="nav-tirdh" role="tabpanel" aria-labelledby="nav-profile-tab">
                    
                    <h6>Millas Navegadas</h6>
                    <hr>
                    <br><br>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-4 offset-md-2">
                            <label for="date_init_ordop">Del : </label>
                            <datetime v-model="dts_millas.date_init" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                           
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="date_init_ordop">Al : </label>
                            <datetime v-model="dts_millas.date_end" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                           
                        </div>
                    </div>

                    <button class="btn btn-outline-primary col-12 col-md-4 offset-md-2" @click="mListPersonsCaptain()">
                        <font-awesome-icon icon="list" size="2x" /> Listar Personal de Capitanias
                    </button>
                    <button class="btn btn-outline-dark col-12 col-md-4" @click="mReportMillasCP('US')" v-if="cDtsUser.roleAssign === 'OPERADOR CAPITANIA'">
                        <font-awesome-icon icon="file-pdf" size="2x" /> Reporte de Millas de la CC.PP.
                    </button>
                    <button class="btn btn-outline-warning col-12 col-md-4" @click="mReportMillasCP('AD')" v-else>
                        <font-awesome-icon icon="file-pdf" size="2x" /> Reporte de Millas de la CC.PP.
                    </button>

                    <br><br>
                    <div class="col-12 table-responsive-md">
                        <transition name="fade" mode="out-in">
                        <table class="table table-hover" v-if="personListMillas.length > 0">
                            <thead>
                                <tr>
                                    <th scope="col" class="table-dark">#</th>
                                    <th scope="col" class="table-dark">GRADOS Y NOMBRES</th>
                                    <th scope="col" class="table-dark">ESTADO ACTUAL</th>
                                    <th scope="col" class="table-dark">REPORTE</th>
                                </tr>
                            </thead>   
                            <tbody>
                                <tr v-for="(value, index) in personListMillas" :key="index">
                                    <td>{{ index + 1}}</td>                            
                                    <td>{{value.grade}} {{value.especiality}} {{value.complete}}</td>                            
                                    <td>{{value.state_current}}</td>
                                    <td>
                                        <button class="btn btn-outline-success" @click="mReportMillasI(value.id_pers_master)">
                                            <font-awesome-icon icon="file-pdf" size="2x" />
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        </transition>
                    </div>

                </div>
                <!-- end tirdh tab -->

            </div>            
        </div>
    <modal-loading :id-modal="id_modal_progress" :title="title_modal" :status-send="send_dispatch" ></modal-loading>
    </div>    
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');

import modalLoading from '../modal/modalLoading';

export default {
    name:'OrdopReport',
    mounted(){
        this.verifyCategory();
        this.callCaptains();
        this.getYears();
    },
    data(){
        return {
            captain_ordop_report:null,
            ports:[],
            send_dispatch:true,
            id_modal_progress:'m_ordop_report',
            title_modal:'Solicitando',
            month_select:0,
            months:[
                {c:1, m:"Enero"},
                {c:2, m:"Febrero"},
                {c:3, m:"Marzo"},
                {c:4, m:"Abril"},
                {c:5, m:"Mayo"},
                {c:6, m:"Junio"},
                {c:7, m:"Julio"},
                {c:8, m:"Agosto"},
                {c:9, m:"Septiembre"},
                {c:10, m:"Octubre"},
                {c:11, m:"Noviembre"},
                {c:12, m:"Diciembre"}
            ],
            years:[],
            year_select:0,
            captain_report_ordop:null,
            ordopsIndividually:[],
            dts_millas:{
                date_init:null,
                date_end:null
            },
            personListMillas:[]
        }
    },
    methods:{
        mReportMillasI(idP=0){
            // aqui llamamos al reporte de millas de la persona de la CC.PP
            if(idP!==0){
                let url_report;
                let adi=this.dts_millas.date_init.split('T');
                this.dts_millas.date_init=adi[0];
                let adf=this.dts_millas.date_end.split('T');
                this.dts_millas.date_end=adf[0];

                // u=`pdfEnrollmentShip/${idb}`;
                // u=`pdfOrdopGral/${this.captain_report_ordop}/${this.month_select}/${this.year_select}?api_token=${Vue.auth.getToken()}`;
                url_report=btoa(`pdfMillasISV/${idP}/${this.dts_millas.date_init}/${this.dts_millas.date_end}`);
                let route = this.$router.resolve({path: `/report/${url_report}`});
                // let route = this.$router.resolve('/link/to/page'); // This also works.
                // let url='http://localhost:8000/api/pdfOrdopI/140?api_token=PwP5t166M2fKTBZvqkhLEzpJYDgET6NTXypEvInVZjqaVClbK6IgOt2eIw7u'
                window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
            }else{
                toastr.warning('seleccione una persona', 'Advertencia');
            }
        },
        mReportMillasCP(trep='US'){
            // aqui llamamos al reporte de millas de la CC.PP. de todos los integrantes de una fecha determinada
            if(this.captain_ordop_report!==0){
                let url_report;            
                let adi=this.dts_millas.date_init.split('T');
                this.dts_millas.date_init=adi[0];
                let adf=this.dts_millas.date_end.split('T');
                this.dts_millas.date_end=adf[0];

                url_report=btoa(`pdfMillasCP/${this.captain_ordop_report}/${this.dts_millas.date_init}/${this.dts_millas.date_end}/${trep}`);
                console.log(this.captain_ordop_report);
                let route = this.$router.resolve({path: `/report/${url_report}`});
                // let route = this.$router.resolve('/link/to/page'); // This also works.
                // let url='http://localhost:8000/api/pdfOrdopI/140?api_token=PwP5t166M2fKTBZvqkhLEzpJYDgET6NTXypEvInVZjqaVClbK6IgOt2eIw7u'
                window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
            }else{
                toastr.warning('seleccione una capitania', 'Advertencia');
            }
        },
        async mListPersonsCaptain(){
            console.log('llamando al personal de la capitania');
            this.personListMillas=[];            
            // listamos al personal para la baja de personal
            let captaintemp= this.captain_ordop_report;
            if(captaintemp===0){
                    toastr.warning('Seleccione una Capitania', 'Advertencia');
                    return false;
            }

            let url=`getPersonsCaptain/${captaintemp}?api_token=${Vue.auth.getToken()}`;
            // let url=`requestCapitan`;
            // aqui listamos el personal de capitanias en el siguiente array
            let lcp=await axios.get(url);
            
            if(lcp.data.length > 0){
                this.personListMillas=lcp.data;                
            }else{
                toastr.info(`La Capitania de Puerto no registra personal`, 'Advertencia');
            }
            
            // console.log(this.personListMillas);

        },
        mGetReportGral(){
            // this.title_modal='Descargando';
            // this.activeModal(this.id_modal_progress);
            if(this.captain_ordop_report!==0){
                let url_report;            
                // u=`pdfEnrollmentShip/${idb}`;
                // u=`pdfOrdopGral/${this.captain_report_ordop}/${this.month_select}/${this.year_select}?api_token=${Vue.auth.getToken()}`;
                url_report=btoa(`pdfOrdopGral/${this.captain_ordop_report}/${this.month_select}/${this.year_select}`);
                let route = this.$router.resolve({path: `/report/${url_report}`});
                // let route = this.$router.resolve('/link/to/page'); // This also works.
                // let url='http://localhost:8000/api/pdfOrdopI/140?api_token=PwP5t166M2fKTBZvqkhLEzpJYDgET6NTXypEvInVZjqaVClbK6IgOt2eIw7u'
                window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
            }else{
                toastr.warning('seleccione una capitania', 'Advertencia');
            }
            
        },
        mReportI(id){
            // console.log(`el id es ${id}`);
            // this.title_modal='Descargando';
            
            // let route = this.$router.resolve({path: `pdfOrdopI/${id}?api_token=${Vue.auth.getToken()}`});
            let url_report=btoa(`pdfOrdopI/${id}`)
            let route = this.$router.resolve({path: `/report/${url_report}`});
            // let route = this.$router.resolve('/link/to/page'); // This also works.
            // let url='http://localhost:8000/api/pdfOrdopI/140?api_token=PwP5t166M2fKTBZvqkhLEzpJYDgET6NTXypEvInVZjqaVClbK6IgOt2eIw7u'
            window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
            
        },
        async mGetIndividuallyOrdop(){
            if(this.captain_ordop_report!==0){
                this.ordopsIndividually=[];
                let rOrdopsI=await axios.get(`getOrdopsI/${this.captain_ordop_report}/${this.month_select}/${this.year_select}?api_token=${Vue.auth.getToken()}`);
                // verificar que datos estan llegando del servidor.
                console.log(rOrdopsI);
                if(rOrdopsI.data.length > 0){
                    this.ordopsIndividually=rOrdopsI.data;
                }else{
                    toastr.info('No existen Registros en estos periodos', 'Advertencia');
                }
            }else{
                toastr.warning('Seleccione una capitania de Puerto', 'Advertencia');
            }
        },
        getYears(){
            let ya=new Date();
            this.year_select=ya.getFullYear();
            this.month_select=ya.getMonth()+1;
            const init=2018;
            this.years=[];
            for(let i=init; i<=this.year_select; i++){
                let ai={c:i};
                this.years.push(ai);
            }
            let  today = new Date();
            let m = today.getMonth() + 1;
            let mes = (m < 10) ? '0' + m : m;
            let d = today.getDate();
            let dia= (d < 10) ? '0'+d : d;
            let date_aux=today.getFullYear()+'-'+mes+'-'+dia;
            this.dts_millas.date_init=date_aux;
            this.dts_millas.date_end=date_aux; 
            // this.dts_millas.date_init=`${ya.getFullYear()}-${ya.getDay()}-${ya.getMonth()}`;
        },
        async callCaptains(){
            let cp=await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`);
            // console.log(cp);
            this.captain_report_ordop=this.cDtsUser.portId;
            this.ports=cp.data;
        },
        verifyCategory(){
            this.captain_ordop_report=this.cDtsUser.role===4 ? this.cDtsUser.portId : 0;
            // this.captain_process_ordop=this.captain_ordop;
            // console.log(`la capitanias es ${this.captain}`);
        },
        activeModal(e){
            $(`#${e}`).modal('show');
        },
        inactiveModal(e){
            $(`#${e}`).modal('hide');
        }
    },
    computed:{
        cDtsUser(){
            return this.$store.getters.getUserState;
        }
    },
    watch:{
        port_query(newQuery){
            axios.get(`searchPort/${newQuery}?api_token=${Vue.auth.getToken()}`)
                .then((res) => {
                    // console.log(res.data)
                    this.portsRegister = res.data
                    // this.users = res.data.items
                }).catch(error => {
                    console.log(error);
                })
        }        
    },    
    components:{
        'modal-loading':modalLoading
    },
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            value=value.toLowerCase();
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    }
}
</script>

<style>

.required-text{
    color:red; 
    font-weight:bold;
}
</style>



// WEBPACK FOOTER //
// src/components/ordop/OrdopReport.vue